export default __webpack_public_path__ + "static/media/kent_icon.f8b952d6.svg";